export default __webpack_public_path__ + "static/media/Menny.49fadfb0.jpg";